import useParts from "../../data/Parts/useParts";
import Modal from "../../layouts/Modal";
import { IEbayPart } from "../../models/EbayPart/EbayPart";
import Form from "../base/Form/Form";
import { UseFormReturn } from "react-hook-form";
import { Button } from "../base/Button";
import { IPartCategory } from "../../models/Category/Category";
import { useEffect, useState } from "react";
import CategorySelect from "./CategorySelect";

interface IPartCategoryFormValues {
  category: IPartCategory | undefined;
}

interface IPartCategorySubmitData {
  categoryId: string | undefined;
  categoryName: string | undefined;
  parts: number[];

  saveSearchTerm: boolean;
  include: string | null;
  exclude: string | null;
}

export default function PartsCategoryModal({
  open,
  setOpen,
  parts,
  saveSearchTerm = false,
  include = null,
  exclude = null,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  parts?: IEbayPart[];
  saveSearchTerm?: boolean;
  include?: string | null;
  exclude?: string | null;
}) {
  const { assignCategory } = useParts({ limit: undefined });
  const [error, setError] = useState<string | undefined>(undefined);

  const onSubmit = (data: any) => {
    setError(undefined); // Reset error state

    const assignData : IPartCategorySubmitData = {
      categoryId: data.category?.id,
      categoryName: data.category?.name,
      parts: parts?.map((part) => +part.id) || [],
      saveSearchTerm: saveSearchTerm,
      include: include ? include.trim() : null,
      exclude: exclude ? exclude.trim() : null,
    };

    console.log("Assigning category with data:", assignData);

    assignCategory.mutate(assignData, {
      onSuccess: () => {
        console.log("Category assigned successfully");
        setOpen && setOpen(false);
      },
      onError: (error) => {
        console.error("Error assigning category:", error);
        setError("Failed to assign category. Please try again.");
      },
    });
  };

  useEffect(() => {
    if (!open) {
      setError(undefined);
    }
  }, [open])

  return (
    <Modal open={open} setOpen={setOpen} width="sm:max-w-2xl">
      <div className="flex justify-between items-center">
        <h1 className="text-xl">
          {"Edit " + parts?.length + " Part Categories"}
        </h1>
      </div>
      <div className="mt-4">
        <Form<IPartCategoryFormValues>
          onSubmit={onSubmit}
        >
          {({ register, setValue }: UseFormReturn<IPartCategoryFormValues>) => (
            <div className="space-y-4 border-t border-gray-200">
              <CategorySelect register={register} setValue={setValue} label="Select Category" />

              {error && (<small className="text-red-500">{error}</small>)}

              <div className="flex gap-x-4">
                <Button type="button" onClick={() => {setOpen && setOpen(false);}}>
                  Cancel
                </Button>
                <Button type="submit">
                  Save
                </Button>
              </div>
            </div>
          )}
        </Form>
      </div>
    </Modal>
  );
}